import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import actions from '../../actions/actions';
import {IntlProvider} from 'react-intl';
import {EdapProvider} from '@homeaway/react-event-tracking';
import {formatLocale} from '../../utils/localization';
import GiftCard from '../GiftCard/GiftCard';
import loadLocaleData from '../../utils/loadLocaleData';

function mapStateToProps(state) {
    // Each container component will likely only pull in the state that
    // it cares about. Doing so will eliminate unnecessary rerenders.
    return state;
}

function mapDispatchToProps(dispatch) {
    return {actions: bindActionCreators(actions, dispatch), dispatch};
}

const defaultFields = {eventcategory: 'testpost'};

@connect(
    mapStateToProps,
    mapDispatchToProps
)
class GiftCardRedemptionContainer extends Component {
    constructor(props) {
        super(props);
        const {
            system: {locale}
        } = props;
        loadLocaleData(locale);
    }
    render() {
        const {
            translations,
            system: {locale}
        } = this.props;
        const intlLocale = formatLocale(locale);
        return (
            <EdapProvider fields={defaultFields}>
                <IntlProvider locale={intlLocale} messages={translations}>
                    <GiftCard />
                </IntlProvider>
            </EdapProvider>
        );
    }
}

export default GiftCardRedemptionContainer;
